<script setup lang="ts">
import AppSidebar from '@/components/app-sidebar'
import AppToast from '@/components/app-toast'
import type { Props } from './type'

defineOptions({
  name: 'AppShell',
})

defineProps<Props>()
</script>

<template>
  <div class="app-shell">
    <AppSidebar />

    <main class="app-shell__main">
      <slot />
    </main>

    <AppToast />
  </div>
</template>

<style scoped>
.app-shell {
  display: grid;
  grid-template-columns: 155px minmax(0, 1fr);
  min-height: 100vh;
  background: var(--profile-bg, #fff);
}

.app-shell__main {
  min-width: 0;
  padding: 8px;
}

@media (max-width: 1024px) and (min-width: 961px) {
  .app-shell {
    grid-template-columns: 76px minmax(0, 1fr);
  }
}

@media (max-width: 960px) {
  .app-shell {
    grid-template-columns: minmax(0, 1fr);
  }

  .app-shell__main {
    padding: 4px;
  }
}
</style>
